import { render, staticRenderFns } from "./transactionsList.vue?vue&type=template&id=d5403334&scoped=true&"
import script from "./transactionsList.vue?vue&type=script&lang=js&"
export * from "./transactionsList.vue?vue&type=script&lang=js&"
import style0 from "./transactionsList.vue?vue&type=style&index=0&id=d5403334&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5403334",
  null
  
)

export default component.exports